module.exports = __webpack_public_path__ + "img/sleep.8955dceb.jpg";